export function Chair(props) {
  return (
    <svg {...props} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 2C11.4477 2 11 2.44772 11 3V19H14V11H26V19H29V3C29 2.44772 28.5523 2 28 2H27C26.4477 2 26 2.44772 26 3V4H14V3C14 2.44772 13.5523 2 13 2H12ZM9 21C9 20.4477 9.44772 20 10 20H30C30.5523 20 31 20.4477 31 21V23C31 23.5523 30.5523 24 30 24V37C30 37.5523 29.5523 38 29 38H28C27.4477 38 27 37.5523 27 37V30H13V37C13 37.5523 12.5523 38 12 38H11C10.4477 38 10 37.5523 10 37L10 24C9.44772 24 9 23.5523 9 23V21ZM27 28V24H13V28H27Z" fill="currentColor"></path>
    </svg>
  );
}
